<template>
  <div
    v-if="shouldRenderTranscript"
    class="refapp-video-transcript"
    data-testid="refapp-video-transcript"
  >
    <details class="refapp-video-transcript__toggle">
      <summary
        class="refapp-video-transcript__toggle-summary"
        data-testid="refapp-video-transcript-summary"
      >
        {{ localTranscript.title }}
      </summary>
      <div class="refapp-video-transcript__content" data-testid="refapp-video-transcript-content">
        <div v-html="localTranscript.content" />
      </div>
    </details>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'refapp-video-transcript',
  inject: ['transcript', 'providerId'],
  data() {
    return {
      localTranscript: this.transcript,
    };
  },
  computed: {
    shouldRenderTranscript() {
      return !!this.localTranscript?.title && !!this.localTranscript?.content;
    },
  },
  mounted() {
    eventBus.on(`transcript-updated-${this.providerId}`, this.updateTranscript);
  },
  unmounted() {
    eventBus.off(`transcript-updated-${this.providerId}`, this.updateTranscript);
  },
  destroyed() {
    eventBus.off(`transcript-updated-${this.providerId}`, this.updateTranscript);
  },
  methods: {
    updateTranscript(transcript) {
      this.localTranscript = transcript;
    },
  },
};
</script>
